import tokenStore from 'services/token-store'
import Raven from 'raven-js'
import config from 'config'

export default {

  setStore(store) {
    this.store = store
  },

  fetch(url, params) {
    return this.xhr(url, params)
  },

  xhr(url, params = {}, token = {}) {
    const { method, responseType = 'json', onProgress, blob, body } = params
    const headers = !blob ? this.getJsonHeaders(params.headers) : this.getHeaders(params.headers)
    const xhr = new XMLHttpRequest()

    xhr.open(method || 'get', params.outsideUrl ? url : this.getUrl(url))

    if (responseType) {
      // If responseType is json set xhr's responseType to empty string
      // because IE doesn't support json type
      xhr.responseType = responseType === 'json' ? '' : responseType
    }

    Object.keys(headers).forEach(key => xhr.setRequestHeader(key, headers[key]))

    if (onProgress) {
      (blob ? xhr.upload : xhr).onprogress = onProgress
    }

    const promise = new Promise(
      (resolve, reject) => {
        xhr.onload = () => {
          if (xhr.status === 204) {
            resolve('')
          } else if (xhr.status >= 200 && xhr.status < 300) {
            // If expecting json repsonse parse response, otherwise return raw response.
            // Do not parse empty response string as it does not work.
            const response = (['', 'json'].indexOf(responseType) > -1 && xhr.response.length > 0) ? JSON.parse(xhr.response) : xhr.response
            resolve(response)
          } else {
            let errorReason = 'statusText' in xhr ? xhr.statusText : xhr.status
            // for strange cases when Error: null
            if (!errorReason) { errorReason = `None of xhr.statusText and xhr.status, error for url: ${url}` }
            const error = new Error(errorReason)
            error.response = xhr
            reject(error)
          }
        }
        xhr.onerror = (event) => {
          reject(event)
        }

        // eslint-disable-next-line no-param-reassign
        token.abort = () => {
          xhr.abort()
          reject('aborted')
        }
      },
    )

    xhr.send(blob ? blob.slice(0, blob.size, 'application/octet-stream') : this.getBody(body))

    return promise
  },

  getUrl(url = '') {
    return `${config.API_ENDPOINT}${url}`
  },

  getHeaders(headers) {
    try {
      const csrfToken = tokenStore.getToken()

      if (csrfToken) {
        return {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': csrfToken,
          ...headers,
        }
      }
    } catch (error) {
      Raven.captureException(new Error('Failed to get token from localStorage'), {
        extra: {
          originalError: error,
          headers,
        },
      })
    }

    return { 'X-Requested-With': 'XMLHttpRequest', ...headers }
  },

  getJsonHeaders(headers) {
    return {
      Accept: 'application/json, */*',
      'Content-Type': 'application/json',
      ...this.getHeaders(headers),
    }
  },

  getBody(body) {
    if (typeof body === 'undefined' || body == null) {
      // Return empty body or backend will crash with IE
      return JSON.stringify({})
    }
    if (typeof body === 'object') {
      return JSON.stringify(body)
    }
    return body
  },
}
